/**
 * Example cohort data for Cohort Analyzer exploration
 * Contains 3 pre-configured cohorts with interesting biological/clinical comparisons
 */

export const exampleCohorts = [
  {
    cohortId: "Example Cohort 1",
    cohortDescription: "Participants with Ganglioglioma NOS who underwent surgical treatment - demonstrating low-grade tumor characteristics and treatment outcomes",
    participants: [
      { participant_id: "PBBPGL", id: "2d1c334a-6239-51d5-9699-37c73b77aa80", study_id: "phs002790"},
      { participant_id: "PBBSTM", id: "c2e2b326-edf3-515b-bf01-cecbcb5cbcc7", study_id: "phs002790"},
      { participant_id: "PBBRIL", id: "e7abf40a-83cb-51e6-b445-c78ed213885b", study_id: "phs002790"},
      { participant_id: "PBBUXY", id: "c75ea660-9f73-5512-b83c-a8ff50bc1c8d", study_id: "phs002790"},
      { participant_id: "PBBSZR", id: "8b6e14ea-3f12-5ab8-a8ab-70d4e1ae0621", study_id: "phs002790"},
      { participant_id: "PBBLLB", id: "2ed15c6b-f0ee-5199-9e64-04ef3d18e4e5", study_id: "phs002790"},
      { participant_id: "PBBPPY", id: "20e1f608-0c26-5a2b-b405-30fa72fe7594", study_id: "phs002790"},
      { participant_id: "PBBKXM", id: "bb477cb3-6b14-5245-a98c-30a56bd945b8", study_id: "phs002790"},
      { participant_id: "PBBNGE", id: "bcd51e2d-82ed-5f2c-bd74-91def5636c5c", study_id: "phs002790"},
      { participant_id: "PBBIJB", id: "a931d5d8-4247-5a0e-8aac-770eb86cb7cf", study_id: "phs002790"},
      { participant_id: "PBBRJF", id: "9dfbe833-387b-5367-9723-30b8ca2b1318", study_id: "phs002790"},
      { participant_id: "PBBWJX", id: "c6dc811c-0833-5eb8-800a-a053a7c197ea", study_id: "phs002790"},
      { participant_id: "PBBMYK", id: "73e45a43-ba12-5de7-af42-10b463eef84b", study_id: "phs002790"},
      { participant_id: "PBBUKV", id: "607e775a-359c-5bc9-adca-ce5563b094e5", study_id: "phs002790"},
      { participant_id: "PBBNFS", id: "29682295-91fc-50c4-a79b-d3a7165999e6", study_id: "phs002790"},
      { participant_id: "PBBPWE", id: "e8d0a3a8-6c1c-5a84-8b96-fd5a892d4841", study_id: "phs002790"},
      { participant_id: "PBBNHL", id: "b4e52683-87cc-5355-8658-64e2c57a1059", study_id: "phs002790"},
      { participant_id: "PBBRXN", id: "ab035b02-5634-581a-be64-3d387b1ec260", study_id: "phs002790"},
      { participant_id: "PBBSTE", id: "92fc71d8-7921-5158-b05f-9b62c6049405", study_id: "phs002790"},
      { participant_id: "PBBJGY", id: "bb276044-22c0-57a0-afa7-7f429d50aaee", study_id: "phs002790"},
      { participant_id: "PBBNSG", id: "c053f488-8a03-5a02-9e25-80b5e530f66e", study_id: "phs002790"},
      { participant_id: "PBBNFF", id: "b5ac6b48-d12e-5f09-8bf8-ebd525bd8333", study_id: "phs002790"},
      { participant_id: "PBBNXT", id: "cea2396a-faa2-5fcb-83fd-6b18fb6ed3df", study_id: "phs002790"},
      { participant_id: "PBBPME", id: "1c3b4540-a0f9-53d9-aa8a-b2b2c1950397", study_id: "phs002790"}
    ],
    lastUpdated: new Date().toISOString(),
  },
  {
    cohortId: "Example Cohort 2",
    cohortDescription: "Participants with malignant Glioma treated with chemotherapy and immunotherapy - representing aggressive treatment approaches for high-grade tumors",
    participants: [
      {participant_id: "PBBIXN", id: "32081222-44ab-52c2-8c71-412f8ad052a2", study_id: "phs002790"},
      {participant_id: "PBBLWR", id: "d571a981-4a6b-5e92-9f4d-1e00b490632b", study_id: "phs002790"},
      {participant_id: "PBBMZW", id: "a44872e0-75ae-5cb7-ae10-df6eb9de3174", study_id: "phs002790"},
      {participant_id: "PBBHYH", id: "5c9592ac-1d4d-518f-b3fb-8566df82257d", study_id: "phs002790"},
      {participant_id: "PBBMCU", id: "2e21199a-4e48-54d4-8184-2ca2e8df0877", study_id: "phs002790"},
      {participant_id: "PBBIGN", id: "da75b116-328d-55bc-9cc4-36de07573c2e", study_id: "phs002790"},
      {participant_id: "PBBIIW", id: "0c22e3aa-cf35-59fc-9d84-efe55bd30652", study_id: "phs002790"},
      {participant_id: "PBBLPZ", id: "7684a9c9-a1eb-55a5-9726-6b41a22e2761", study_id: "phs002790"},
      {participant_id: "PBBIXR", id: "32499ce7-0e27-52d5-92ca-92008026733f", study_id: "phs002790"},
      {participant_id: "PBBMBK", id: "676ca9f5-4f53-58d5-be7c-69cd2a50c737", study_id: "phs002790"},
      {participant_id: "PBBIUS", id: "8d8d856a-07da-528a-bfdc-5fc342af947d", study_id: "phs002790"},
      {participant_id: "PBBHWP", id: "5b9c6b6f-ad53-58ea-84d4-a1d40c39533f", study_id: "phs002790"},
      {participant_id: "PBBKKT", id: "05da7d74-7b48-5b1d-bd7d-7e73daa252b3", study_id: "phs002790"},
      {participant_id: "PBBMYI", id: "77107ad6-eab2-5a69-9f2c-1d7b177e359d", study_id: "phs002790"},
      {participant_id: "PBBMCL", id: "0ab53737-3db3-5990-b239-932ad767c821", study_id: "phs002790"},
      {participant_id: "PBBJHS", id: "1d537642-d97d-596d-bb86-1b4f3bef4f07", study_id: "phs002790"},
      {participant_id: "PBBLFW", id: "1a624f69-1f04-5526-9acc-fc88161d1a44", study_id: "phs002790"},
      {participant_id: "PBBMYD", id: "bf3bf626-3dd4-58cf-9b04-1859c7bcaf44", study_id: "phs002790"},
      {participant_id: "PBBKKX", id: "399cbc1d-5fd7-527d-9719-0adf4e80b777", study_id: "phs002790"},
      {participant_id: "PBBKTU", id: "64fe0c53-4108-57e4-b93d-224620d4c4e4", study_id: "phs002790"},
      {participant_id: "PBBMNW", id: "a6c98d5f-b0f9-5cca-8a9b-76ec426c82cd", study_id: "phs002790"},
      {participant_id: "PBBKSG", id: "2c9d539e-f939-56fc-bf94-541789f54a04", study_id: "phs002790"},
      {participant_id: "PBBIUN", id: "a7a1e4d1-ff02-53e1-9090-663989eb87eb", study_id: "phs002790"},
      {participant_id: "PBBKNA", id: "d4d43314-3562-5533-b8f7-51fa10ea8521", study_id: "phs002790"},
      {participant_id: "PBBMCC", id: "4e63df3a-c7e1-5981-948a-6a8b44217b62", study_id: "phs002790"}
    ],
    lastUpdated: new Date().toISOString(),
  },
  {
    cohortId: "Example Cohort 3",
    cohortDescription: "Participants with malignant Glioma treated with radiation therapy - showcasing radiation-based treatment protocols for brain tumors",
    participants: [
      {participant_id: "PBBVDX", id: "b4333b25-eab9-516b-97d7-43eaae70e956", study_id: "phs002790"},
      {participant_id: "PBBTCS", id: "2e3373a4-bf0f-574b-abb0-d2469c79ef67", study_id: "phs002790"},
      {participant_id: "PBBMZW", id: "a44872e0-75ae-5cb7-ae10-df6eb9de3174", study_id: "phs002790"},
      {participant_id: "PBBRKP", id: "aa1bd6b5-e37b-5a9e-9ce0-73952b62500b", study_id: "phs002790"},
      {participant_id: "PBBSIU", id: "087fc5ba-edd2-5aeb-86e6-35707e6e0aa4", study_id: "phs002790"},
      {participant_id: "PBBNIZ", id: "17c8be66-7c97-5072-bcb7-8a4b01d58d76", study_id: "phs002790"},
      {participant_id: "PBBTRI", id: "393580f2-b047-552d-b294-100526eb7ddb", study_id: "phs002790"},
      {participant_id: "PBBVPC", id: "f699aac3-3c40-5eae-82d7-6b43300096f8", study_id: "phs002790"},
      {participant_id: "PBBLHT", id: "36809423-8761-5de4-b1b9-416084d367aa", study_id: "phs002790"},
      {participant_id: "PBBNCU", id: "e1606b98-e12a-5e10-93d7-89d42c4efac3", study_id: "phs002790"},
      {participant_id: "PBBVUD", id: "b3ea88a9-b281-5f7f-9b00-11154b89d4b5", study_id: "phs002790"},
      {participant_id: "PBBIUS", id: "8d8d856a-07da-528a-bfdc-5fc342af947d", study_id: "phs002790"},
      {participant_id: "PBBVZJ", id: "b8bc5e52-a36a-5273-a51f-1c6f9be5a96c", study_id: "phs002790"},
      {participant_id: "PBBHWP", id: "5b9c6b6f-ad53-58ea-84d4-a1d40c39533f", study_id: "phs002790"},
      {participant_id: "PBBTED", id: "5246b855-ad42-5775-9dcf-10e9af5ea878", study_id: "phs002790"},
      {participant_id: "PBBJHS", id: "1d537642-d97d-596d-bb86-1b4f3bef4f07", study_id: "phs002790"},
      {participant_id: "PBBLFW", id: "1a624f69-1f04-5526-9acc-fc88161d1a44", study_id: "phs002790"},
      {participant_id: "PBBMYD", id: "bf3bf626-3dd4-58cf-9b04-1859c7bcaf44", study_id: "phs002790"},
      {participant_id: "PBBKKX", id: "399cbc1d-5fd7-527d-9719-0adf4e80b777", study_id: "phs002790"},
      {participant_id: "PBBUNA", id: "3f98e91f-9fdd-5ae2-88de-d5b3ac2d7a29", study_id: "phs002790"},
      {participant_id: "PBBKSG", id: "2c9d539e-f939-56fc-bf94-541789f54a04", study_id: "phs002790"},
      {participant_id: "PBBIUN", id: "a7a1e4d1-ff02-53e1-9090-663989eb87eb", study_id: "phs002790"},
      {participant_id: "PBBRKJ", id: "ca4410c6-b37c-5116-95a6-12b9ea3bbecd", study_id: "phs002790"},
      {participant_id: "PBBMJP", id: "3207915d-2741-528c-b9c5-3935eb5b6376", study_id: "phs002790"}
    ],
    lastUpdated: new Date().toISOString(),
  }
];
/**
 * Utility function to extract example cohort keys from the exampleCohorts array
 * Returns cohort IDs in lowercase format as used by the application
 */
export const getExampleCohortKeys = () => {
  return exampleCohorts.map(cohort => cohort.cohortId);
};

/**
 * Example button configuration for UI text and tooltips
 */
export const exampleButtonConfig = {
  buttonText: "Add Example Cohorts",
  tooltip: {
    enabled: "Generate a set of example cohorts to explore the Cohort Analyzer.",
    replacement: "Clicking this will generate a new set of example cohorts and remove the existing example cohorts.",
    disabled: "Cannot add example cohorts. You have reached the maximum limit of 20 cohorts. Please delete some cohorts first."
  }
};